import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { api } from '../api-client.config';

type CreateCodeParams = {
  code: string;
  name: string;
};

const createCode = async (body: CreateCodeParams) => api.post('/codes', body);

export const useCreateCodeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['create-code'],
    mutationFn: createCode,
    onSuccess: () => {
      toast.success('Code created successfully');

      queryClient.invalidateQueries({
        queryKey: ['codes'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
